import { WpReferral } from './wp-referral.model';

export class WpEtEnrollmentIndvChildren {
    constructor(
        public id?: number,
        public referralId?: string,
        public referredDt?: any,
        public programCd?: string,
        public childName?: string,
        public childDobDt?: any,
        public childApName?: string,
        public childSupportSw?: string,
        public wpReferral?: WpReferral,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-et-enrollment-indv-children.model.ts